import { createAsyncThunk } from '@reduxjs/toolkit';

import { OrdersHttpGetService } from 'Feature/Common/Common/Services/OrderHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetPaymentByOrderIdQuery } from '../../Common/types/Queries/IGetPaymentByOrderIdQuery';

export const getPaymentByOrderId = createAsyncThunk(
  'Payment/GetPaymentByOrderId',
  async (query: IGetPaymentByOrderIdQuery) => {
    return await OrdersHttpGetService({
      url: `${_apiPathManagerConfig?.Orders.Payment.GetPaymentByOrderId}`,
      params: query,
    });
  }
);
